<button
  #trigger="cdkOverlayOrigin"
  cdkOverlayOrigin
  class="select"
  ttSelectTrigger
  [attr.readonly]="readonly ? '' : null"
  [class.select_selected--active]="isExpanded()"
  [disableAutoWidth]="disableAutoWidth()"
  [disabled]="isDisabled"
  (click)="toggle()">
  <span>
    {{ selectedLabel() }}
  </span>
  <mat-icon [icon]="'chevron-down'" [iconSize]="16" />
</button>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayLockPosition
  [cdkConnectedOverlayOpen]="_delayedExpanded()"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayWidth]="triggerWidth() > 0 ? triggerWidth() : 'auto'"
  (backdropClick)="close()"
  (detach)="close()"
  (positionChange)="_positionChanges$.next($event)">
  <ng-content />
</ng-template>
